module.exports = __webpack_public_path__ + "img/videoPoster2.b10425ff.jpg";